import { setOptions, importLibrary } from "@googlemaps/js-api-loader"
import { useAuthStore } from "@/store/auth.store.ts"
import { storeToRefs } from "pinia"

let initialized = false

export const useGoogleMaps = () => {
  const activeUserStore = useAuthStore()
  const { activeUser } = storeToRefs(activeUserStore)

  if (!initialized) {
    setOptions({
      key: activeUser.value?.activeTenant.tenantSettings?.apiKeyGoogleMaps ?? undefined,
      v: "quarterly"
    })
    initialized = true
  }

  return {
    importLibrary
  }
}
